import React, { useState, useEffect, useRef } from "react";
import classes from "./style.module.css";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import "./sliderStyles.css";
import TickSound from "../../../../../assets/Audio/clickSoundEffect.wav";

export default function RangeSliderContainer({
  min,
  max,
  setMin,
  setMax,
  stepSize,
}) {
  const [values, setValues] = useState([min, max]);
  const [toolTipPositions, setToolTipPositions] = useState([0, 0]);
  const sliderElement = useRef();
  const TickAudio = new Audio(TickSound);
  const soudMuted = JSON.parse(localStorage.getItem("soudMuted"));

  const handleChange = (newValues) => {
    if (soudMuted) {
      TickAudio.play();
    }
    setValues(newValues);
  };

  useEffect(() => {
    setMin(values[0]);
    setMax(values[1]);
    if (sliderElement.current) {
      let width = sliderElement.current.clientWidth;
      const positions = values.map((value) => {
        const normalizedValue = ((value - min) / (max - min)) * 0.92;
        return normalizedValue * width;
      });
      setToolTipPositions(positions);
    }
  }, [values]);

  return (
    <div className={classes.sliderContainer}>
      <div className={classes.rangeContainer} ref={sliderElement}>
        <div
          className={classes.toolTipContainer}
          style={{ left: `${toolTipPositions[0]}px` }}
        >
          <p>{values[0]}</p>
        </div>
        <div
          className={classes.toolTipContainer}
          style={{ left: `${toolTipPositions[1]}px` }}
        >
          <p>{values[1]}</p>
        </div>
        <RangeSlider
          id="range-slider-gradient"
          values={values}
          step={stepSize}
          defaultValue={[min, max]}
          onInput={handleChange}
          tooltipPlacement="top"
          min={min}
          max={max}
        />
      </div>
      <div className={classes.rangeTextContainer}>
        <div>
          <p>{max}</p>
        </div>
        <div>
          <p>{min}</p>
        </div>
      </div>
    </div>
  );
}
